import { DocumentName } from './components/DocumentName/DocumentName';

export const formattedRows = (data: any) => {
	return (
		data?.files?.map((row: any) => ({
			name: <DocumentName key={row.name} file={row} />,
			type: row.type,
			category: row.category,
			created: row.updatedAt.split('T')[0].split('-').reverse().join('/'),
		})) ?? []
	);
};
